import { useEffect, useMemo, useState } from "react";
import { store } from "../store";
import {
  getIntlLocale,
  getStoredLanguage,
  getTmdbImageLanguages,
  getTmdbLanguage,
  normalizeLanguage
} from "./language";
import { t } from "./translations";

const readLanguage = () =>
  normalizeLanguage(store?.getState?.()?.settings?.language || getStoredLanguage());

export const useI18n = () => {
  const [language, setLanguage] = useState(readLanguage);

  useEffect(() => {
    const syncLanguage = () => setLanguage(readLanguage());
    syncLanguage();
    const unsubscribe = store?.subscribe?.(syncLanguage);
    window.addEventListener?.("storage", syncLanguage);
    return () => {
      unsubscribe?.();
      window.removeEventListener?.("storage", syncLanguage);
    };
  }, []);

  return useMemo(() => ({
    language,
    locale: getIntlLocale(language),
    tmdbLanguage: getTmdbLanguage(language),
    tmdbImageLanguages: getTmdbImageLanguages(language),
    t: ((value: unknown) => t(value, language)) as typeof t
  }), [language]);
};
